export default {
  HEADLINE: 'Rechnungsvorlage',
  LABEL: [
    'Steuernummer: {taxNumber}',
    'Rechnungsnummer: {invoiceNumber}',
    'Datum: {currentDate}',
  ],
  SUBJECT: 'Rechnung - Honorar',
  TEXT: [
    'Sehr geehrte Damen und Herren,',
    'für meine erbrachten ärztlichen Leistungen, im Rahmen von KV-Vertretungen, stelle ich Ihnen wie folgt in Rechnung:',
    'Pos.',
    'Bezeichnung',
    'Menge',
    'Einzelpreis',
    'Summe',
    '1',
    'KV-Dienst von {startDate} bis {endDate}',
    'Honorar für reguläre Dienststunden',
    '2',
    'Leistungsbezogene, gestaffelte Zusatzvergütung für Hausbesuchsdienste pro gesetzlich versicherter Patient',
    'Zu zahlender Betrag: {fee}',
    'Leistungen für ärztliche Heilbehandlung sind von der Umsatzsteuer laut §4 Nr.14 Umsatzsteuergesetz (UStG) befreit.',
    'Bitte überweisen Sie den Betrag ohne Abzüge bis zum {dueDate} auf das Konto',
    'Kontoinhaber: {accountHolder}',
    'Institut: {bank}',
    'IBAN: {iban}',
    'BIC: {bic}',
    'Mit freundlichen Grüßen',
  ],
  LEGACY_TEXT: [
    'Extravergütung ab dem {patientLimit}. Patienten in {serviceDuration} Std.',
    'insgesamt {patientCount} Notfallscheine',
  ],
  BREAK_ADDENDUM: '(inkl. Pause von {breakDuration}h)',
  SUMMARY: {
    TITLE: 'Tätigkeitsnachweis für Auftrag Nr:',
    SUBSTITUTE_TITLE: 'Angaben zum Vertretungsarzt',
    SUBSTITUTE_NAME: 'Title / Name',
    SUBSTITUTE_IBAN: 'IBAN',
    SUBSTITUTE_BANK: 'BIC/Bank',
    SUBSTITUTE_TAX: 'Steuernummer',
    CUSTOMER_TITLE: 'Angaben zum Kunden',
    CUSTOMER_NAME: 'Arzt',
    CUSTOMER_ESTABLISHMENT: 'Praxis',
    CUSTOMER_ADDRESS: 'Adresse',
    CUSTOMER_INVOICING_EMAIL: 'Rechnungs-E-Mail-Adresse',
    CUSTOMER_SECONDARY_SERVICE_AREA: 'Dienstgebiet',
    SERVICE_TITLE: 'Angaben zum Dienst',
    DAY: 'Tag',
    DATE: 'Datum',
    START: 'Von',
    END: 'Bis',
    DURATION: 'Stunden',
    DURATION_CONTENT: '{ time }h a { price }€',
    DURATION_BREAK: '(exkl. Pause von { time } Std.)',
    COMPLETE: 'Anzahl der Scheine',
    EXTRA: 'Extravergütung ab dem',
    EXTRA_LEFT_TITLE: 'Bitte Anzahl eintragen:',
    EXTRA_LEFT_1: 'Totenschein(e)',
    EXTRA_LEFT_2: 'Privatpatient(en)',
    EXTRA_LEFT_3: 'Telefonische Beratung(en). Bitte bei telefon. Beratungen Notfallschein ausfüllen"!',
    EXTRA_LEFT_4: 'Totenscheine. Privatpatienten und telefonische Beratungen gehören nicht zur Anzahl der Scheine.',
    NOTICE: 'Hinweis:',
    EXTRA_RIGHT_TITLE: 'Bitte ankreuzen:',
    PHONE: 'Telefonnummer:',
    DATE_LOCATION: 'Ort, Datum',
    STAMP: 'Unterschrift / Stempel vertretender Arzt',
    ORDER_NUMBER: 'Auftrag:',
  },
};
